<template>
  <avtalat-spinner v-if="isLoading" />
  <AppContainer v-if="isInitialized && !isLoading">
    <AppHeader>
      <SearchBar v-if="!isHome" />
    </AppHeader>
    <RouterView />
    <AppFooter />
  </AppContainer>
  <div v-if="!isInitialized && !isLoading">
    Något har gått fel. Kontakta support.
  </div>
</template>
<script setup lang="ts">
import type { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { computed, onMounted, ref } from "vue";
import { RouterView } from "vue-router";

import AppFooter from "@/layout/AppFooter.vue";
import SearchBar from "@/components/SearchBar.vue";
import AppHeader from "@/layout/app-header/AppHeader.vue";
import AppContainer from "@/layout/AppContainer.vue";
import { useApi } from "@/composables/useApi";
import { useAppInsights } from "@/composables/useAppInsights";
import { useNavigation } from "@/composables/useNavigation";

import {
  useAuthStore,
  useConfigStore,
  useSvarsmallarStore,
  useUserProfileStore,
} from "./stores";

const isInitialized = ref(false);
const isLoading = ref(true);
const navigation = useNavigation();
const apiClient = useApi();
const configStore = useConfigStore();
const userProfileStore = useUserProfileStore();
const svarsmallarStore = useSvarsmallarStore();

const appInsights = useAppInsights();
const isHome = computed(() => navigation.currentRoute.name === "home");

if (appInsights) {
  (appInsights as ApplicationInsights).trackPageView();
}

onMounted(async () => {
  try {
    await useAuthStore().init();
    await Promise.all([
      userProfileStore.init(apiClient),
      configStore.init(apiClient),
      svarsmallarStore.init(apiClient),
    ]);

    isInitialized.value = true;
  } catch {
    isInitialized.value = false;
  } finally {
    isLoading.value = false;
  }
});
</script>
